import React from 'react';
import Slider from 'react-slick';
import HeaderSecondary from 'src/components/partners/header-secondary';
import ForgotPasswordForm from 'src/components/partners/forgot-password';
import DottedSmallIcon from 'icons/dotted-small.svg';
import DottedBigIcon from 'icons/dotted-big.svg';
import { sliderData, sliderSettings } from 'src/components/partners/login/constants';
import { PARTNER } from 'src/formMapper';

const ForgotPassword = () => {
  return (
    <div className='min-h-screen relative'>
      <div className='absolute h-full w-1/2 inset-0 bg-link-water bg-opacity-30 z-0' />
      <div className='container mx-auto px-4 relative z-10 py-4 lg:py-6'>
        {/* Header */}
        <HeaderSecondary />
        <div className='grid grid-cols-12 items-center'>
          {/* Left Side */}
          <div className='col-span-4'>
            <div className='hidden lg:block items-center justify-center text-center px-4'>
              <div>
                <h2 className='app-heading-primary text-primary'>
                  {PARTNER.header.forget_password_text}<br />
                  {PARTNER.header.forget_password_text_rem}
                </h2>
                <div className='block'>
                  <Slider {...sliderSettings}>
                    {sliderData.map((step, index) => (
                      <div key={String(index)}>
                        <img className='mt-6 mx-auto' src={step.imgUrl} alt={step.title} />
                        <h2 className='app-text-dm-large text-secondary mt-4'>{step.title}</h2>
                        <p className='mt-1 app-text-dm-small text-gray opacity-80'>{step.description}</p>
                      </div>
                    ))}
                  </Slider>
                </div>
              </div>
            </div>
          </div>
          {/* Right Side */}
          <div className='col-span-12 lg:col-span-6 col-start-1 lg:col-start-6 relative'>
            <div className='absolute -left-11 top-36 z-0 hidden sm:block'>
              <DottedBigIcon />
            </div>
            <div className='absolute -right-16 bottom-36 z-0 hidden sm:block'>
              <DottedBigIcon />
            </div>
            <div className='absolute left-36 -top-7 z-0 hidden sm:block'>
              <DottedSmallIcon />
            </div>
            <div className='bg-white shadow-card-shadow-secondary rounded-20 px-6 lg:px-16 py-5 lg:py-12 relative z-10'>
              <div>
                <h2 className='app-heading-main text-primary'>{PARTNER.header.forget_password_email_text}</h2>
                <p className='mt-2 app-text-dm-regular text-gray opacity-80'>
                  {PARTNER.subHeader.forget_password_subheader_text}
                </p>
              </div>
              <div className='mt-8'>
                <ForgotPasswordForm />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
